export default __webpack_public_path__ + "static/media/typeracer.7de2ca26.png";